import { MessageMedia } from "./message.model";

export class VoiceCallModel {
    _id?: any;
    uuid: string;
    revision: string;
    status: string;
    vrsn: string;
    endpoint_uuid: string;
    receiver_id: string;
    call_start_timestamp: Date;
    call_end_timestamp: Date;
    direction: string;
    duration: number;
    call_price: number;
    call_price_unit: string;
    voice_conversation_uuid: string;
    task_guid?: string;
    call_participants?: CallParticipant[];
    call_recording?: MessageMedia;
    forward_from?: string;
  }

  export class CallParticipant{
    // This class is used to assign agents to voice calls
    // example attribute data*
    //    sender_type: human/bot
    //    assignee_guid: agent making or receiving the call
    sender_type: string;
    assignee_guid: string;
  }
